import { useContext } from 'react'
import { useQuery } from '@tanstack/react-query'
import Page from '../pages/Page'
import useQueryLibrary from '../../hooks/useQueryLibrary'
import FetchContext from '../../context/fetch/FetchContext'
import JournalTable from './JournalTable'

export default function JournalPage() {
    const queryLibrary = useQueryLibrary()
    const fetcher = useContext(FetchContext)

    const {
        data: result,
        isFetching,
        isLoading,
    } = useQuery({
        queryKey: queryLibrary.journalsQuery(),
        queryFn: () => fetcher.fetchJournals(),
    })

    const records = result ?? []

    return (
        <Page
            className="journal"
            title="יומן"
            busy={isFetching || isLoading}
        >
            <JournalTable records={records} />
        </Page>
    )
}
